import { render, staticRenderFns } from "./FormTeacherStudent.vue?vue&type=template&id=337a09d8&scoped=true"
import script from "./FormTeacherStudent.vue?vue&type=script&lang=js"
export * from "./FormTeacherStudent.vue?vue&type=script&lang=js"
import style0 from "./FormTeacherStudent.vue?vue&type=style&index=0&id=337a09d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337a09d8",
  null
  
)

export default component.exports